export const useCanxLogger = () => {
  return useNuxtApp().$logger as CanxLogger
}
